<template>
  <div class="myForm">
    <a-form-model ref="ruleForm" :model="dataForm" :rules="rules">
      <a-card style="border: none; border-radius: 12px; margin-bottom: 20px">
        <div slot="title">培训方案</div>
        <a-row>
          <a-col :span="12">
            <a-form-model-item ref="name" prop="name">
              <FormItem label="方案名称">
                <a-input
                  style="width: 100%; max-width: 575px"
                  :disabled="readonly"
                  v-model="dataForm.name"
                  placeholder="请输入方案名称"
                  size="large"
                  @change="
                    () => {
                      $refs.name.onFieldBlur();
                    }
                  "
                >
                </a-input>
              </FormItem>
            </a-form-model-item>
            <a-form-model-item>
              <FormItem label="负责人">
                <a-input
                  style="width: 100%; max-width: 575px"
                  :disabled="readonly"
                  v-model="dataForm.principal"
                  placeholder="请输入培训负责人"
                  size="large"
                >
                </a-input>
              </FormItem>
            </a-form-model-item>
            <a-form-model-item>
              <FormItem label="提示">
                <a-alert
                  style="width: 100%; max-width: 575px"
                  show-icon
                  message="注意班组、项目及公司负责人签字会同步到三级教育卡中。"
                  type="info"
                />
              </FormItem>
            </a-form-model-item>
            <a-form-model-item ref="jyr1" prop="jyr1">
              <FormItem label="公司负责人签字">
                <div class="jyr">
                  <img
                    v-if="dataForm.jyr1"
                    :src="dataForm.jyr1"
                    alt="签字图片加载失败"
                  />
                  <div class="qianzi" @click="sign(1)">
                    {{ dataForm.jyr1 ? "重新签字" : "点击签字" }}
                  </div>
                </div>
              </FormItem>
            </a-form-model-item>
            <a-form-model-item ref="jyr2" prop="jyr2">
              <FormItem label="项目部负责人签字">
                <div class="jyr">
                  <img
                    v-if="dataForm.jyr2"
                    :src="dataForm.jyr2"
                    alt="签字图片加载失败"
                  />
                  <div class="qianzi" @click="sign(2)">
                    {{ dataForm.jyr2 ? "重新签字" : "点击签字" }}
                  </div>
                </div>
              </FormItem>
            </a-form-model-item>
            <a-form-model-item ref="jyr3" prop="jyr3">
              <FormItem label="班组签字">
                <div class="jyr">
                  <img
                    v-if="dataForm.jyr3"
                    :src="dataForm.jyr3"
                    alt="签字图片加载失败"
                  />
                  <div class="qianzi" @click="sign(3)">
                    {{ dataForm.jyr3 ? "重新签字" : "点击签字" }}
                  </div>
                </div>
              </FormItem>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-row>
              <a-col style="width: 100%; max-width: 670px">
                <a-form-model-item ref="bad" prop="bad">
                  <FormItem label="不及格分数" :labelStyle="{ color: 'red' }">
                    <a-input
                      :disabled="readonly"
                      v-model="dataForm.bad"
                      placeholder="请输入不及格分数"
                      size="large"
                      type="number"
                      suffix="分以下"
                      @blur="
                        () => {
                          dataForm.bad = parseInt(dataForm.bad);
                          $refs.bad.onFieldBlur();
                        }
                      "
                    >
                    </a-input>
                  </FormItem>
                </a-form-model-item>
              </a-col>
              <a-col style="width: 100%; max-width: 670px">
                <a-form-model-item>
                  <FormItem label="黄码分数" :labelStyle="{ color: 'orange' }">
                    <a-input
                      :value="
                        '大于等于' +
                        dataForm.bad +
                        ' 并 ' +
                        '小于' +
                        dataForm.good
                      "
                      placeholder="请输入黄码分数"
                      size="large"
                      disabled
                    >
                    </a-input>
                  </FormItem>
                </a-form-model-item>
              </a-col>
              <a-col style="width: 100%; max-width: 670px">
                <a-form-model-item ref="good" prop="good">
                  <FormItem label="绿码分数" :labelStyle="{ color: 'green' }">
                    <a-input
                      :disabled="readonly"
                      v-model="dataForm.good"
                      placeholder="请输入绿码分数"
                      size="large"
                      suffix="分及以上"
                      @blur="
                        () => {
                          dataForm.good = parseInt(dataForm.good);
                          $refs.good.onFieldBlur();
                        }
                      "
                    >
                    </a-input>
                  </FormItem>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-card>
      <a-card style="border: none; border-radius: 12px; margin-bottom: 20px">
        <div slot="title">选择课程</div>
        <div>
          <a-button
            type="primary"
            icon="plus"
            @click="addClass"
            v-if="!readonly"
            >添加课程</a-button
          >
          <div v-if="classes.length > 0" style="margin-top: 20px">
            <a-table
              filterMultiple
              :columns="columns"
              :data-source="classes"
              :pagination="false"
              rowKey="id"
            >
              <span slot="url" slot-scope="text, record">
                {{ record.belong == 1 ? "系统课程" : text }}
              </span>
              <span slot="action" slot-scope="text, record" v-if="!readonly">
                <a-space>
                  <a-button size="small" type="link" @click="showFiles(record)"
                    >查看
                  </a-button>
                  <a-button size="small" type="link" @click="del(record.id)"
                    >删除
                  </a-button>
                </a-space>
              </span>
            </a-table>
          </div>
        </div>
      </a-card>
      <a-card style="border: none; border-radius: 12px; margin-bottom: 20px">
        <div slot="title">
          <!-- 选择课程 -->
          <a-radio-group
            name="radioGroup"
            v-model="radioGroup"
            @change="changeRadio"
            v-if="!programId"
          >
            <a-radio :value="1"> 选择题库 </a-radio>
            <a-radio :value="2"> 自由组题</a-radio>
            <a-radio :value="3"> 上传题库 </a-radio>
          </a-radio-group>
          <div v-else>选择课程</div>
        </div>
        <!-- 新增显示下面三个类型切换 -->
        <div v-if="!programId && !readonly">
          <div v-if="radioGroup == 1">
            <a-select
              style="width: 200px"
              placeholder="请选择题库"
              v-model="topicsArrValue"
              @change="topicsArrValueChange"
              size="large"
              :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
            >
              <a-select-option v-for="v in topicsArr" :key="v.id">
                {{ v.name }}
              </a-select-option>
            </a-select>
          </div>
          <a-button
            v-else-if="radioGroup == 2"
            type="primary"
            icon="plus"
            @click="addTopic"
            >添加题目</a-button
          >
          <a-button
            v-else-if="radioGroup == 3"
            type="primary"
            icon="plus"
            @click="uploadTopicLibrary"
            >上传题库</a-button
          >
        </div>
        <div v-else>
          <a-button
            type="primary"
            icon="plus"
            @click="addTopic"
            v-if="!readonly"
            >添加题目</a-button
          >
        </div>
        <div v-if="topics.length > 0" style="margin-top: 20px">
          <a-table
            filterMultiple
            :columns="columns2"
            :data-source="topics"
            :pagination="false"
            rowKey="id"
          >
            <span slot="type" slot-scope="text">
              {{
                text == 1
                  ? "单选题"
                  : text == 2
                  ? "判断题"
                  : text == 3
                  ? "多选题"
                  : ""
              }}
            </span>
            <span slot="answer" slot-scope="text, record">
              <a-button type="link">
                {{
                  record.type == 2
                    ? text === "A" &&
                      (record.q1.indexOf("对") > -1 ||
                        record.q1.indexOf("正确") > -1)
                      ? "✅"
                      : "❌"
                    : text.split("").join("、")
                }}
              </a-button>
            </span>
            <span slot="action" slot-scope="text, record" v-if="!readonly">
              <a-space>
                <a-button size="small" type="link" @click="showTopic(record)"
                  >查看
                </a-button>
                <a-button size="small" type="link" @click="delTopic(record.id)"
                  >删除
                </a-button>
              </a-space>
            </span>
          </a-table>
        </div>
      </a-card>
      <a-row type="flex" justify="end">
        <a-col v-if="!readonly">
          <a-button @click="cancel">取消</a-button>
          <a-button type="primary" v-if="!programId" @click="addorupdateProgram"
            >新增培训方案</a-button
          >
          <a-button type="primary" v-if="programId" @click="addorupdateProgram"
            >修改培训方案</a-button
          >
        </a-col>
        <a-col v-if="readonly">
          <a-button @click="cancel" size="large">取消</a-button>
        </a-col>
      </a-row>
    </a-form-model>
    <ShowFile ref="showFile"></ShowFile>
    <UploadTopics
      ref="uploadTopics"
      @ok="getTopicsLibrarySelect"
    ></UploadTopics>
    <a-modal
      v-model="sign_visible"
      :title="
        sign_type == 1
          ? '公司负责人签字'
          : sign_type == 2
          ? '项目负责人签字'
          : '班组签字'
      "
      @ok="signHandleOk"
      destroyOnClose
      centered
      :keyboard="false"
      :maskClosable="false"
      :confirmLoading="signbtnloading"
      width="auto"
      @cancel="handleCancel"
      :getContainer="getContainer"
    >
      <div class="content">
        <div class="msg" v-if="!sign_img">请签字</div>
        <img v-else :src="sign_img" width="100%" height="100%" alt="" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import ShowFile from "./showfile";
import UploadTopics from "./uploadTopics";
import { topicsLibrarySelect, tipics } from "@/request/classes";
import FormItem from "@/components/FormItem/index";
import SignClient from "@/utils/sign/index";
import { dataURLtoBlob } from "@/utils/os";
import { upload } from "@/request/sys";
export default {
  components: { ShowFile, UploadTopics, FormItem },
  props: {
    //培训id
    programId: {
      type: [String, Number],
      default: "",
    },
    //课程列表
    classes: {
      type: Array,
      default() {
        return [];
      },
    },
    //题库列表
    topics: {
      type: Array,
      default() {
        return [];
      },
    },
    //确认按钮loading
    confirmLoading: {
      type: Boolean,
      default: false,
    },
    //是否只读
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      radioGroup: 1,
      dataForm: {
        name: "", //方案名称
        principal: "", //方案负责人
        bad: 85,
        good: 90,
        jyr1: "", //公司负责人签字
        jyr2: "", //项目部负责人签字
        jyr3: "", //班组签字
      },
      sign_type: "",
      sign_visible: false,
      Sign: null,
      signbtnloading: false,
      sign_img: "",
      labelCol: { span: 3 },
      wrapperCol: { span: 14 },
      rules: {
        name: [
          { required: true, message: "请输入培训方案名称", trigger: "blur" },
          {
            min: 1,
            max: 12,
            message: "培训方案名称长度为 1 至 50个字符",
            trigger: "blur",
          },
        ],
        bad: [
          {
            required: true,
            type: "number",
            message: "请输入培训方案名称",
            trigger: "blur",
          },
        ],
      },
      topicsArr: [],
      topicsArrValue: undefined,
      columns: [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 100,
          align: "center",
          customRender: (text, record, index) => {
            return index + 1;
          },
        },
        {
          title: "课程分类",
          dataIndex: "classify",
          key: "classify",
          align: "left",
          width: 200,
          // customRender: (value, row, index) => {
          //   console.log(row,'row')
          //   const obj = {
          //     children: value,
          //     attrs: {},
          //   };
          //   if (index === 2) {
          //     obj.attrs.colSpan  = 2;
          //   }
          //   // These two are merged into above cell
          //   if (index === 3) {
          //     obj.attrs.colSpan  = 0;
          //   }
          //   if (index === 4) {
          //     obj.attrs.colSpan = 0;
          //   }
          //   return obj;
          // },
        },
        {
          title: "课程名称",
          dataIndex: "name",
          key: "name",
          align: "left",
        },
        {
          title: "文件地址",
          dataIndex: "url",
          key: "url",
          align: "left",
          scopedSlots: { customRender: "url" },
        },
        {
          title: "格式",
          dataIndex: "type",
          key: "type",
          align: "left",
        },
        {
          title: "操作",
          key: "action",
          dataIndex: "action",
          align: "left",
          scopedSlots: { customRender: "action" },
        },
      ],
      columns2: [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 100,
          align: "center",
          customRender: (text, record, index) => {
            return index + 1;
          },
        },
        {
          title: "题库名称",
          dataIndex: "library_name",
          key: "library_name",
          align: "center",
          width: 300,
        },
        {
          title: "题目类型",
          dataIndex: "type",
          key: "type",
          align: "center",
          width: 120,
          scopedSlots: { customRender: "type" },
        },
        {
          title: "文件地址",
          dataIndex: "question",
          key: "question",
          align: "center",
        },
        {
          title: "正确答案",
          dataIndex: "answer",
          key: "answer",
          align: "center",
          scopedSlots: { customRender: "answer" },
        },
        {
          title: "操作",
          key: "action",
          dataIndex: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
    };
  },
  mounted() {
    this.getTopicsLibrarySelect();
  },
  beforeDestroy() {
    this.handleCancel();
  },
  methods: {
    sign(type) {
      if (type == 1) this.sign_img = this.dataForm.jyr1;
      if (type == 2) this.sign_img = this.dataForm.jyr2;
      if (type == 3) this.sign_img = this.dataForm.jyr3;
      this.sign_type = type;
      this.sign_visible = true;
      if (this.readonly) return;
      this.Sign = new SignClient();
      this.Sign.setInitokCallback(() => {
        this.$message.success("请开始签字");
      });
      this.Sign.setInkCallback((base64) => {
        this.sign_img = base64;
      });
      this.Sign.setErrCallback((res) => {
        this.$error({
          centered: true,
          title: "温馨提示",
          content: res.message,
          getContainer: ()=> document.getElementById("bodyContnet"),
          onOk: () => {
            // this.handleCancel();
          },
        });
      });
      this.Sign.initDevice();
    },
    //保存
    signHandleOk() {
      if (!this.sign_img) {
        return this.handleCancel();
      }
      this.signbtnloading = true;
      this.base64Upload(this.sign_img)
        .then((res) => {
          if (this.sign_type == 1) this.dataForm.jyr1 = res.data.url;
          if (this.sign_type == 2) this.dataForm.jyr2 = res.data.url;
          if (this.sign_type == 3) this.dataForm.jyr3 = res.data.url;
          this.handleCancel();
        })
        .finally(() => {
          this.signbtnloading = false;
        });
    },
    //base64图片上传服务器返回url地址
    base64Upload(base64, name = "文件名称") {
      return new Promise((resovle, reject) => {
        if (base64.indexOf("http://") > -1 || base64.indexOf("https://") > -1) {
          return resovle({ data: { url: base64 } });
        }
        const file = dataURLtoBlob(base64, encodeURIComponent(name));
        let formData = new FormData();
        formData.append("file", file);
        upload(formData)
          .then((res) => {
            resovle(res);
          })
          .catch(() => {
            reject();
          });
      });
    },
    handleCancel() {
      this.sign_visible = false;
      if (this.Sign) {
        this.Sign.close();
        this.Sign = null;
      }
    },
    //切换上传类型
    changeRadio(e) {
      this.getTopicsLibrarySelect();
      if (e.target.value == 1 || e.target.value == 2) {
        // this.topicsArrValue = undefined;
        // this.$emit("resetTopics");
      }
    },
    //获取题库选择数据
    getTopicsLibrarySelect() {
      topicsLibrarySelect().then((res) => {
        this.topicsArr = res.data;
      });
    },
    //切换选择的题库
    topicsArrValueChange(e) {
      tipics({ library_id: e }).then((res) => {
        this.$emit("confirmTopics", res.data);
      });
    },
    //添加课程
    addClass() {
      this.$emit("changeType", 2);
    },
    //添加题目
    addTopic() {
      this.$emit("changeType", 3);
    },
    //查看文件
    showFiles(record) {
      console.log(record);
      this.$refs.showFile.init(record);
    },
    //删除一个课程
    del(id) {
      this.$emit("del", id);
    },
    //删除一个题目
    delTopic(id) {
      this.$emit("delTopic", id);
    },
    //上传题库
    uploadTopicLibrary() {
      this.$refs.uploadTopics.init();
    },
    //取消
    cancel() {
      this.$emit("cancel");
    },
    //新增/修改方案
    addorupdateProgram() {
      // this.$emit("addorupdateProgram");
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("addorupdateProgram", this.dataForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //查看题目
    showTopic(record) {
      this.$emit("showTopic", record);
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style scoped lang='scss'>
.jyr {
  display: flex;
  flex-wrap: wrap;
  img {
    width: 200px;
    height: 120px;
    // border: 1px solid red;
  }
  .qianzi {
    color: #1890ff;
    cursor: pointer;
    margin-left: 10px;
  }
}
.content {
  width: 387px;
  height: 244px;
  border: 1px solid #f5f6fa;
  margin: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.msg {
  font-size: 30px;
  line-height: 20px;
  color: #b9d5fd;
}
</style>